import * as Yup from 'yup'
import { INVALID_PHONE_NUMBER } from 'constants/errors'

export const schemaSearchExistingIso = Yup.object().shape({
  firstName: Yup.string().trim().required('First Name is required'),
  lastName: Yup.string().trim().required('Last Name is required'),
  phone: Yup.string()
    .required('Phone is required')
    .test(
      'isFullPhoneNumber',
      INVALID_PHONE_NUMBER,
      (val) => Boolean(val && val.replace(/\s/g, '').indexOf('_') < 0),
    ),
  email: Yup.string().email('Must be a valid email').required('Email is required'),
})
